import React, { useState, useEffect } from "react";
import { PageView } from "../../../../GlobalComponents";
import styled from "@emotion/styled";
import AdminNav from "../../admin-nav";
import { Stack } from "@mui/material";
import ImportContactsModal from "../import-contacts-modal";
import ListBrowser from "./components/ListBrowser";
import ListViewer from "./components/ListViewer";
import { useSearchParams } from "react-router-dom";
import {
  initErrorTesting,
} from "./api/config";
import { useLists, useArchivedLists } from "./api";

export default function ListManager() {
  initErrorTesting();

  const [selectedList, setSelectedList] = useState<List | undefined>();
  const [searchParams, setSearchParams] = useSearchParams();

  const {
    data: allLists,
    isLoading: isLoadingLists,
    error,
    refetch,
  } = useArchivedLists();

  const onListSelect = (list: List) => {
    setSelectedList(list);
    setSearchParams({ id: String(list.id), name: list.name });
  };

  // Load list from URL on first mount
  useEffect(() => {
    const id = searchParams.get("id");
    const name = searchParams.get("name");

    if (id && name) {
      const foundList = allLists?.find((l) => l.id.toString() === id);
      if (foundList) setSelectedList(foundList);
      else setSelectedList({ id: parseInt(id), name } as List);
    }
  }, [allLists]);

  return (
    <PageView headerProps={{ isAdmin: true, rightContent: <AdminNav /> }}>
      <Container>
        <Stack width="25%" height="100%">
          <ListBrowser selected_id={selectedList?.id} onClick={onListSelect} />
        </Stack>
        <Stack width="75%" height="100%">
          <ListViewer list={selectedList} />
        </Stack>
      </Container>
    </PageView>
  );
}

const Container = styled.div`
  display: flex;
  background-color: white;
  box-shadow: 0px 0px 10px #35466933;
  height: 80vh;
  width: 100%;
  overflow: hidden;
  
`;

const HeaderWrapper = styled.div`
  background-color: grey;
  height: 200px;
  width: 100%;
`;
